export default {
    bruto: 'Raw',
    formatado: 'Formatted',
    copiar: 'Copy',
    copiado_sucesso: 'Content copied successfully!'
}